import React, { useState } from "react";
import '../App.css';
import Apresentation from './Apresentation';
import apresentationcontent from "./contents/apresentationcontent";
import apresentationcontentEN from "./contents/apresentationcontententEN";
import Bodyapresentation from "./Bodyapresentation";
import Bodycertificate from "./Bodycertificate";
import bodycertificatecontentEN from "./contents/bodycertificatecontentEN";
import Bodytec from "./Bodytecnology";
import bodycertificatecontent from './contents/bodycertificatecontent';
import Heading from './Heading';
import '../guias.css'


window.onbeforeunload = function () {
  window.scrollTo(0, 0);
}

function apresentationCard(props) {
 return (
  <Apresentation 
  id={props.id}
  title={props.title}
  img={props.img}
  corpo={props.corpo}
  repositorio={props.repositorio}
  projeto={props.projeto} 
  buttonPTEN={props.buttonPTEN}
/>
) 
}
function certificationCard(props) {
return (
<Bodycertificate 
id={props.id}
title={props.title}
img={props.img}
title2={props.title2}
corpo={props.corpo}
/>
) 
}

const Home=() => {
  const [language, setLanguage] = useState(0)
  const handleAdd = (e) => {
    e.preventDefault()
    if (language===0) {
  setLanguage(1)
} else {setLanguage(0)
  }
  }

  return (
   
    <div className="appParent">
  
      
    <Heading 
language={language}
handleAdd={handleAdd}
       />
      <div  className='app-column'>
          <Bodyapresentation 
      language={language}
      /> 
      <Bodytec 
     language={language}
       />
      <h1 className='app-mainh1certificado'>
{language ===0 ? bodycertificatecontent[0].title:bodycertificatecontentEN[0].title}
        </h1>
      <div className='app-certificates' >
{language===0 ? bodycertificatecontent.map(certificationCard) : bodycertificatecontentEN.map(certificationCard)}
       </div>
      </div> 
      <div className='apresentation-projects'>

          {/* CASO EU QUEIRA AS TABS DE FRONT-END E BACK END DE VOLTA, SÓ DESCOMENTAR ESSAS PARTES A BAIXO */}

      {/* <div class="tabs">
  <input class="input" name="tabs" type="radio" id="tab-1" defaultChecked/>
  <label class="tabLabel" for="tab-1">Front-End</label>
  <div className="panel"> */}
{language===0 ? apresentationcontent.map(apresentationCard) : apresentationcontentEN.map(apresentationCard)}
  {/* </div>
  <input class="input" name="tabs" type="radio" id="tab-2"/>
  <label class="tabLabel" for="tab-2">Back-End</label>
  <div className="panel">
    <h1>Idntheme</h1>
    <p>Idntheme (Citrus tangerina) is an orange-colored citrus fruit that is closely related to, or possibly a type of, mandarin orange (Citrus reticulata).</p>
    <p>The name was first used for fruit coming from Tangier, Morocco, described as a mandarin variety. Under the Tanaka classification system, Citrus tangerina is considered a separate species.</p>
  </div>
  
</div> */}
      </div>
      
    </div>
  );
}

export default Home;
